import Loadable from 'react-loadable';
import Loading from 'System/views/loading.jsx';

const Clientlist = Loadable({
	loader: () => import(/* webpackChunkName: "Clients" */ "./views/clientlist.jsx"),
	loading: Loading
});

const Clientdetail = Loadable({
	loader: () => import(/* webpackChunkName: "Clients" */ "./views/clientdetail.jsx"),
	loading: Loading
});

const Confirmedorders = Loadable({
	loader: () => import(/* webpackChunkName: "Orders" */ "./views/confirmedorders.jsx"),
	loading: Loading
});

const Sostituzioni = Loadable({
	loader: () => import(/* webpackChunkName: "Orders" */ "./views/sostituzioni.jsx"),
	loading: Loading
});

const PortafoglioOrdini = Loadable({
	loader: () => import(/* webpackChunkName: "Orders" */ "./views/portafoglioordini.jsx"),
	loading: Loading
});

const Orderdetail = Loadable({
	loader: () => import(/* webpackChunkName: "Orders" */ "./views/orderdetail.jsx"),
	loading: Loading
});

const PortafoglioReclami = Loadable({
	loader: () => import(/* webpackChunkName: "Complaints" */ "./views/portafoglioreclami.jsx"),
	loading: Loading
});


const views = {
	Clientdetail,
	Confirmedorders,
	PortafoglioOrdini,
	Orderdetail,
	Clientlist,
	Sostituzioni,
	PortafoglioReclami
}

export default views;